import React from 'react';
import { Icon } from './Icon.js';
export const IconGripDotsVerticalFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("circle", { cx: "4", cy: "6", r: "1", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("circle", { cx: "8", cy: "6", r: "1", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("circle", { cx: "4", cy: "2", r: "1", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "8", cy: "2", r: "1", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "4", cy: "10", r: "1", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "8", cy: "10", r: "1", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconGripDotsVerticalFill12.js.map